<template>
  <div id="app">

    <header class="header">
      <div class="header_wrap">
        <div class="header_logo">
          <a :href="route('gyms.home')" class="brand-logo">
            <Logo class="header_logo_img" width="163.5" height="28.5" alt="ロード・オブ・ザ・ウォール" />
          </a>
        </div>

        <div class="header_info" v-if="$page.props.auth.user">
          <div class="header_info_role red" v-if="$page.props.auth.user.role == 'admin'">
            Admin
          </div>
          <div class="header_info_role green" v-else-if="$page.props.auth.user.role == 'owner'">
            Gym Owner
          </div>
          <div class="header_climber" id="toggle-menu" @click="showChara = !showChara">
            <figure class="header_climber_avatar">
              <img :src="`/images/char/${$page.props.auth.chara.file_name}.gif`">
            </figure>
          </div>
        </div>

        <div class="header_guest" v-else>
          <div class="header_guest_login">
            <a class="header_guest_login_link" :href="route('login')">
              <img src="/images/common/btn-login-red.svg" alt="ログイン" />
            </a>
          </div>
        </div>

      </div>
    </header>

    <!-- bottom nav START -->

    <ul class="nav" v-if="$page.props.auth.user">
      <li class="nav_list">
        <a :href="route('gyms.home')">
          <img src="/images/nav/icon-home.svg">
        </a>
      </li>
      
      <!-- <li class="nav_list">
        <a href="">
          <img src="/images/nav/icon-heart.svg">
        </a>
      </li>
      <li class="nav_list">
        <a href="">
          <img src="/images/nav/icon-search.svg">
        </a>
      </li> -->
    
      <li class="nav_list">
        <Link :href="`/users/${$page.props.auth.user.id}`">
          <img src="/images/nav/icon-person.svg">
        </Link>
      </li>
    </ul>
    <!-- bottom nav END -->

    <div v-if="$page.props.auth.user" class="header_chara" :class="{ active: showChara }">

      <div class="header_chara_cross" @click="showChara = !showChara">
        <img src="/images/icons/icon-cross.svg">
      </div>
      <div class="header_chara_wrapper">
        <figure class="header_chara_wrapper_avatar">
          <img :src="`/images/char/${$page.props.auth.chara.file_name}.gif`">
        </figure>
        <div class="header_chara_wrapper_name">
          {{ $page.props.auth.chara.name_eng }}
          <span class="header_chara_wrapper_name_jpn">{{ $page.props.auth.chara.name_jpn }}</span>
        </div>
        <div class="header_chara_wrapper_level">
          <div class="header_chara_wrapper_level_heading">LEVEL {{ $page.props.auth.user.level }}</div>
          <div class="header_chara_wrapper_level_bar">
            <span class="header_chara_wrapper_level_bar_exp" :style="{ width: $page.props.auth.chara.exp_this_level/$page.props.auth.chara.exp_range_this_level*100+'%' }"></span>
          </div>
          <div class="header_chara_wrapper_level_point">
            NEXT LEVEL : {{ $page.props.auth.chara.exp_this_level }}/{{ $page.props.auth.chara.exp_range_this_level }}
          </div>
          <div class="header_chara_wrapper_level_exp">
            EXP : {{ $page.props.auth.user.exp }}
          </div>
        </div>

      </div>

    </div>

    <!-- Page Content -->
    <!-- <main class="container"> -->
      <slot />
      <!-- <Side /> -->
    <!-- </main> -->
  </div><!-- end #app -->
  <!-- <Footer /> -->

</template>

<script>
import { ref } from 'vue';
// import BreezeApplicationLogo from '@/Components/ApplicationLogo.vue';
import BreezeDropdown from '@/Components/Dropdown.vue';
import BreezeDropdownLink from '@/Components/DropdownLink.vue';
import BreezeNavLink from '@/Components/NavLink.vue';
import BreezeResponsiveNavLink from '@/Components/ResponsiveNavLink.vue';
import { Link } from '@inertiajs/inertia-vue3';

import Logo from '@/Shared/Logo'
// import Side from '@/Shared/Side'
// import Footer from '@/Shared/Footer'


export default {
  components: {
    BreezeDropdown,
    BreezeDropdownLink,
    BreezeNavLink,
    BreezeResponsiveNavLink,
    Link,
    Logo,
    // Side,
    // Footer
  },
  data () {
    return {
      showChara: false,
      // imgpath: props.auth.chara.file_name
    }
  }
  // props: {
  //   auth: Object,
  // },
  // props: {
  //   gyms: Array
  // },
  // computed: {
  //     hogeURL: function () {
  //       return '/home/' + props.auth.user.id
  //     }
  // }

}


</script>